module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "badge",
    attrs: {
      "href": "https://onatcer.com"
    }
  }, [_c('img', {
    attrs: {
      "width": "35",
      "height": "35",
      "src": "/static/onatcer.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("made by Gregor Vostrak (@onatcer)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63efb351","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Badge.vue
// module id = 229
// module chunks = 1